import { eventTracker } from 'app/modules/Segment';
import {
  FeatureEnum,
  GroupIdEnum,
  OwnerEnum,
} from 'app/modules/Segment/types';
import { useSelector } from 'react-redux';

interface DispatchEventParams {
  eventName: string;
  event_meaning: string;
  component: string;
  feature?: string;
  relevant_user_activity?: boolean;
  properties?: Record<string, unknown>;
  owner?: string;
  groupId?: string;
  libraryName?: string;
}

export const useEventTracker = () => {
  const universalCredits = useSelector(
    (state: ReturnType<any>) =>
      state.universalJusfinder?.isUniversalJusfinder,
  );

  const dispatchEvent = ({
    eventName,
    event_meaning,
    component,
    feature = FeatureEnum.JUSFINDER,
    relevant_user_activity = true,
    properties = {},
    owner = OwnerEnum.JUSFINDER,
    groupId = GroupIdEnum.JUSFINDER_GROUP,
    libraryName = 'jusfinder-library',
  }: DispatchEventParams) => {
    if (!eventName || !event_meaning) return;

    eventTracker.track({
      event: eventName,
      properties: {
        feature,
        owner,
        relevant_user_activity,
        event_meaning,
        isUniversal: universalCredits,
        ...properties,
      },
      context: {
        groupId,
        library: {
          name: libraryName,
          componente: component,
        },
      },
    });
  };

  return { dispatchEvent };
};
